import { RouterLink } from '@redux-first-router-link';
import { push } from 'redux-first-router';
import { useTracking } from 'react-tracking';

import { Box, Text, Row } from '@simplywallst/ui-core';

import { AuthorPhoto, AuthorLink } from './styled';

type AuthorProps = {
  authorSlug: string;
  author: string;
  authorAvatarUrl: string;
  publishedDate: string;
  canonicalUrl: string;
  slug: string;
};
export const Author = ({
  author,
  authorSlug,
  authorAvatarUrl,
  publishedDate,
  canonicalUrl,
  slug,
}: AuthorProps) => {
  const { trackEvent } = useTracking();
  return (
    <Row>
      <Box marginRight="x1" width="24px" height="24px" borderRadius="x20">
        <AuthorPhoto
          src={authorAvatarUrl}
          alt={`${author} avatar`}
          data-cy-id="article-card-author-avatar"
        />
      </Box>
      <AuthorLink
        href={`https://simplywall.st/news/about-simply-wall-st-news/${authorSlug}`}
        data-cy-id="article-card-author-link"
        target="_blank"
        rel="noreferrer"
        onClick={(event) => event.stopPropagation()}
      >
        <Text as="span" typography="xSmall" color="whiteRGBA" opacity={0.6}>
          {author}
        </Text>
      </AuthorLink>
      <Box marginRight="x1" marginLeft="x1">
        <Text as="span" typography="xSmall" color="whiteRGBA" opacity={0.6}>
          |
        </Text>
      </Box>
      <time dateTime={publishedDate} data-cy-id="article-card-time">
        <Text as="span" typography="xSmall" color="whiteRGBA" opacity={0.6}>
          {publishedDate}
        </Text>
      </time>
      <Box marginRight="x1" marginLeft="x1">
        <Text as="span" typography="xSmall" color="whiteRGBA" opacity={0.6}>
          |
        </Text>
      </Box>
      <Box>
        <RouterLink
          noUnderline
          to={`${canonicalUrl}#comments`}
          onClick={(e) => {
            // redux-first-router does not support hash links out of the box
            // https://github.com/faceyspacey/redux-first-router/issues/485
            // https://github.com/faceyspacey/redux-first-router-link/issues/82
            e.preventDefault();
            e.stopPropagation();
            push(`${canonicalUrl}#comments`);
            trackEvent({
              type: 'track',
              subject: 'comments-link',
              action: 'click',
              slug,
            });
          }}
        >
          <Text typography="xSmall" color="whiteRGBA" opacity={0.6}>
            5 comments
          </Text>
        </RouterLink>
      </Box>
    </Row>
  );
};
